import * as React from 'react'

import { Box, dimensions } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import Chip, { LabelChipProps } from 'modules/core/components/Filter/base/Chip'
import ClearValue from 'modules/core/components/Filter/base/ClearValue'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import useFilter from 'modules/core/components/Filter/base/useFilter'
import MonthPicker from 'modules/core/components/MonthPicker'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import {
  FormatTypes,
  dateBackendToShortDMUI,
  dateToString,
  stringToDate,
} from 'modules/core/lib/dates'

export type Props = LabelChipProps & {
  dateFormat?: FormatTypes
  label: string
  defaultOpen?: boolean
  closeOnChange?: boolean
  onToggle?: (open: boolean) => void
  value: string | undefined
  onValueChange: (value?: string | undefined) => void
}

function Body() {
  const { value, onValueChange } = useFilter<string | undefined>()

  const [_value, setValue] = React.useState(value)

  // If value changes from top, let's set it here
  useUnsafeEffect(() => {
    setValue(value)
  }, [value])

  return (
    <Box justifyContent="center" alignItems="center">
      <MonthPicker onChange={onValueChange} value={value} showOnlyPicker />
    </Box>
  )
}

export default function MonthPickerFilter({
  defaultOpen,
  onValueChange,
  onToggle,
  label,
  icon,
  value: valueProp,
  closeOnChange,
  dateFormat,
}: Props) {
  const formatDate = (dateString: string) => {
    if (dateFormat) {
      const date = stringToDate(dateString, 'backend')

      return dateToString(date, dateFormat)
    }

    return dateBackendToShortDMUI(dateString)
  }

  const activeLabel = valueProp && formatDate(valueProp)
  const value = valueProp && dateToString(moment(valueProp), 'ui')

  return (
    <Provider
      defaultOpen={!!defaultOpen}
      value={value}
      onValueChange={onValueChange}
      closeOnChange={closeOnChange}
    >
      <Chip.Toggler
        label={label}
        icon={icon}
        active={!!value}
        activeLabel={activeLabel}
        onToggle={onToggle}
      />
      <Content body={<Body />} footer={<ClearValue />} maxHeight={dimensions.s400} />
    </Provider>
  )
}
